export const REDBOOK_EMOJI = [
  '[微笑R]',
  '[害羞R]',
  '[失望R]',
  '[汗颜R]',
  '[哇R]',
  '[喝奶茶R]',
  '[自拍R]',
  '[偷笑R]',
  '[飞吻R]',
  '[石化R]',
  '[笑哭R]',
  '[赞R]',
  '[暗中观察R]',
  '[买爆R]',
  '[大笑R]',
  '[色色R]',
  '[生气R]',
  '[哭惹R]',
  '[萌萌哒R]',
  '[斜眼R]',
  '[可怜R]',
  '[鄙视R]',
  '[皱眉R]',
  '[抓狂R]',
  '[捂脸R]',
  '[派对R]',
  '[吧唧R]',
  '[惊恐R]',
  '[抠鼻R]',
  '[再见R]',
  '[叹气R]',
  '[睡觉R]',
  '[得意R]',
  '[吃瓜R]',
  '[扶墙R]',
  '[黑薯问号R]',
  '[黄金薯R]',
  '[吐舌头H]',
  '[扯脸H]',
  '[doge]'
];

export const OTHER_EMOJI = [
  '[天幕R]',
  '[卡式炉R]',
  '[折叠椅R]',
  '[营地车R]',
  '[露营灯R]',
  '[露营R]',
  '[渔夫帽R]',
  '[登山鞋R]',
  '[背包R]',
  '[马甲R]',
  '[骑行服R]',
  '[手套R]',
  '[头盔R]',
  '[风镜R]',
  '[公路车R]',
  '[折叠车R]',
  '[飞盘R]',
  '[冲浪板R]',
  '[双翘滑板R]',
  '[陆冲板R]',
  '[长板R]',
  '[种草R]',
  '[拔草R]',
  '[点赞R]',
  '[向右R]',
  '[合十R]',
  '[okR]',
  '[加油R]',
  '[握手R]',
  '[鼓掌R]',
  '[弱R]',
  '[耶R]',
  '[抱拳R]',
  '[勾引R]',
  '[拳头R]',
  '[拥抱R]',
  '[举手R]',
  '[猪头R]',
  '[老虎R]',
  '[集美R]',
  '[仙女R]',
  '[红书R]',
  '[开箱R]',
  '[探店R]',
  '[ootdR]',
  '[同款R]',
  '[打卡R]',
  '[飞机R]',
  '[拍立得R]',
  '[薯券R]',
  '[优惠券R]',
  '[购物车R]',
  '[kissR]',
  '[礼物R]',
  '[生日蛋糕R]',
  '[私信R]',
  '[请文明R]',
  '[请友好R]',
  '[氛围感R]',
  '[清单R]',
  '[电影R]',
  '[学生党R]',
  '[彩虹R]',
  '[爆炸R]',
  '[炸弹R]',
  '[火R]',
  '[啤酒R]',
  '[咖啡R]',
  '[钱袋R]',
  '[流汗R]',
  '[发R]',
  '[红包R]',
  '[福R]',
  '[鞭炮R]',
  '[庆祝R]',
  '[烟花R]',
  '[气球R]',
  '[看R]',
  '[新月R]',
  '[满月R]',
  '[大便R]',
  '[太阳R]',
  '[晚安R]',
  '[星R]',
  '[玫瑰R]',
  '[凋谢R]',
  '[郁金香R]',
  '[樱花R]',
  '[海豚R]',
  '[放大镜R]',
  '[刀R]',
  '[辣椒R]',
  '[黄瓜R]',
  '[葡萄R]',
  '[草莓R]',
  '[桃子R]',
  '[红薯R]',
  '[栗子R]',
  '[红色心形R]',
  '[黄色心形R]',
  '[绿色心形R]',
  '[蓝色心形R]',
  '[紫色心形R]',
  '[爱心R]',
  '[两颗心R]',
  '[浅肤色R]',
  '[中浅肤色R]',
  '[中等肤色R]',
  '[中深肤色R]',
  '[有R]',
  '[可R]',
  '[蹲R]',
  '[零R]',
  '[一R]',
  '[二R]',
  '[三R]',
  '[四R]',
  '[五R]',
  '[六R]',
  '[七R]',
  '[八R]',
  '[九R]',
  '[加一R]',
  '[满R]',
  '[禁R]'
];

export const EMOJI_SET = new Set([...REDBOOK_EMOJI, ...OTHER_EMOJI]);
